export const REVIEWER_STUDIO_TABS = {
  SENSITIVE_ATTRIBUTES: 0,
  WHITELIST_RULES: 1,
  COMPLIANCE_IQ: 2,
  OWASP: 3,
  ONTOLOGY: 4,
  INTERNAL_COMPLIANCE: 5,
  EXTERNAL_COMPLIANCE: 6,
  SUBMIT_FINISH: 7
} as const;

export const GOVERNANCE_TAB_INDICES = [
  REVIEWER_STUDIO_TABS.OWASP,
  REVIEWER_STUDIO_TABS.ONTOLOGY,
  REVIEWER_STUDIO_TABS.INTERNAL_COMPLIANCE,
  REVIEWER_STUDIO_TABS.EXTERNAL_COMPLIANCE
] as const;

export const isGovernanceTab = (tabIndex: number): boolean =>
  (GOVERNANCE_TAB_INDICES as readonly number[]).includes(tabIndex);
